module.exports = __webpack_public_path__ + "static/media/concrete.71d777ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/alset-reactgame-test/commonGameAssets/tiles/concrete.jpg
// module id = 429
// module chunks = 0